module.exports = __webpack_public_path__ + "static/media/gestioneEnte.5e698a7c.png";